import { CloseCircleOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { saveSupportDetails, setGsSelectedTab, setOthersSelectedTab, setSubscriptionSelectedTab } from 'actions/profileNew';
import { Col, Row } from 'antd';
import { Button } from 'components/Button';
import PageHeader from 'components/pageHeader';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router';
import { Notification } from 'services';
// import { ProfileInput } from './detailFields';
import ProfileInput from './detailFields'
import SaveConfirmation from './saveConfirmation';
import { easySwitch } from './subComponents';

const SupportSettings = ({ supportPhones, saveSupportDetails, user, setGsSelectedTab, setSubscriptionSelectedTab, setOthersSelectedTab }) => {
    // const validatePhone = (phone, rawVal) => {
    //     if (!phone || phone === "") return "";
    //     if (rawVal) {
    //         const cleanRaw = rawVal.replace(/[^0-9]/g, '');
    //         if (cleanRaw.startsWith('0')) {
    //             return "Phone number cannot start with 0";
    //         }
    //     }
    //     const clean = String(phone).replace(/[^0-9]/g, '');
    //     let nationalNumber = clean;
    //     if (clean.startsWith('91')) {
    //         nationalNumber = clean.substring(2);
    //     }
    //     if (nationalNumber.length > 0) {
    //         const firstDigit = nationalNumber.charAt(0);
    //         if (firstDigit === '0') {
    //             return "Phone number cannot start with 0";
    //         }
    //         if (firstDigit < '6' || firstDigit > '9') {
    //             return "Phone number must start with 6, 7, 8, or 9";
    //         }
    //     }
    //     if (nationalNumber.length !== 10) {
    //         return "Phone number must be exactly 10 digits";
    //     }
    //     return "";
    // }
    const validatePhone = (phone) => {
        if (!phone || phone === "") return "";

        const digits = String(phone).replace(/\D/g, '');
        const nationalNumber = digits.startsWith('91') ? digits.slice(2) : digits;

        if (nationalNumber.length === 0) return "";

        if (/^[0-5]/.test(nationalNumber)) {
            return "Please enter valid mobile number";
        }

        if (nationalNumber.length !== 10) {
            return "Please enter valid mobile number";
        }

        return "";
    };

    // const validateAllPhones = (list, activeIndex = -1, activeRawVal = "") => {
    //     const newErrors = list.map((phone, idx) => {
    //         const isTarget = idx === activeIndex;
    //         return validatePhone(phone, isTarget ? activeRawVal : undefined);
    //     });

    //     const cleanList = list.map(p => p ? String(p).replace(/[^0-9]/g, '') : '');

    //     for (let i = 0; i < cleanList.length; i++) {
    //         if (cleanList[i] === '') continue;
    //         for (let j = i + 1; j < cleanList.length; j++) {
    //             if (cleanList[j] === '') continue;
    //             if (cleanList[i] === cleanList[j]) {
    //                 newErrors[i] = "Number must be different";
    //                 newErrors[j] = "Number must be different";
    //             }
    //         }
    //     }

    //     return newErrors;
    // }
    const validateAllPhones = (list) => {
        const newErrors = list.map(phone => validatePhone(phone));

        const cleanList = list.map(p =>
            p ? String(p).replace(/\D/g, '') : ''
        );

        for (let i = 0; i < cleanList.length; i++) {
            if (!cleanList[i]) continue;

            for (let j = i + 1; j < cleanList.length; j++) {
                if (!cleanList[j]) continue;

                if (cleanList[i] === cleanList[j]) {
                    newErrors[i] = "Number must be different";
                    newErrors[j] = "Number must be different";
                }
            }
        }

        return newErrors;
    };

    const [phoneList, updatePhoneList] = useState([]);
    const [errors, setErrors] = useState([]);
    const [isSaveHidden, setIsSaveHidden] = useState(false)
    const [showConfirmModal, setShowConfirmModal] = useState(false);

    useEffect(() => {
        updatePhoneList([...supportPhones])
        setErrors(validateAllPhones(supportPhones))
    }, [supportPhones]);

    useEffect(() => {
        setIsSaveHidden(
            JSON.stringify(supportPhones) === JSON.stringify(phoneList)
        )
    }, [phoneList])

    const history = useHistory();

    const handleAddField = () => {
        const newList = [...phoneList, ''];
        updatePhoneList(newList)
        setErrors(validateAllPhones(newList))
    }

    // const handleChange = (e, index) => {
    //     let val = e;
    //     if (val && val.startsWith('+91') && val.length > 13) {
    //         val = val.slice(0, 13);
    //     }
    //     const newList = [...phoneList];
    //     newList[index] = val;
    //     updatePhoneList(newList)
    //     let rawVal = "";
    //     if (document.activeElement && (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA')) {
    //         rawVal = document.activeElement.value;
    //     }
    //     setErrors(validateAllPhones(newList, index, rawVal));
    // }
    const handleChange = (value, index) => {
        let val = value || "";

        const digits = val.replace(/\D/g, '');
        let nationalNumber =
            digits.startsWith('91') ? digits.slice(2) : digits;

        // prevent entering more than 10 digits
        if (nationalNumber.length > 10) {
            nationalNumber = nationalNumber.slice(0, 10);
        }

        val = digits.startsWith('91')
            ? `+91${nationalNumber}`
            : nationalNumber;

        const newList = [...phoneList];
        newList[index] = val;

        updatePhoneList(newList);
        setErrors(validateAllPhones(newList));
    };

    const handleSaveConfirm = (callback, buttonCallback) => {
        const params = { supportPhones: phoneList };
        delete params.basicprofile;
        saveSupportDetails(params, () => {
            if (callback) callback();
            history.push('/account-settings');
        }, buttonCallback)
    }

    const handleSaveClick = () => {
        if (!phoneList[phoneList?.length - 1] || phoneList[phoneList?.length - 1] === "") {
            Notification.error('error', "Phone number should not be empty!")
        } else if ((new Set(phoneList)).size !== phoneList.length) {
            Notification.error('error', "Phone numbers dupicated!")
        } else {
            setShowConfirmModal(true)
        }
    }

    const removeNumber = (index) => {
        const newList = [...phoneList];
        newList.splice(index, 1);
        updatePhoneList(newList)
        setErrors(validateAllPhones(newList))
    }


    const handleBackPress = () => {
        if (["/general-settings", "/view-kyc", "/subscriptions", "/support-settings", "/user-profile/others"].includes(history.location?.state?.from)) {
            history.push('/account-settings')
        } else {
            history.goBack()
        }
    }

    return (
        <div style={{ height: "100%" }}>
            <PageHeader
                title="aulas Care Support"
                onBackPress={handleBackPress}
                actions={[
                    isSaveHidden ? null :
                        <Button type="link" style={{ fontSize: 14 }}
                            onClick={() => handleSaveClick()}
                            disabled={
                                phoneList.some(item => !item || item === "") ||
                                errors.some(err => err && err !== "") ||
                                (new Set(phoneList)).size !== phoneList.length
                            }
                        >SAVE</Button>
                ]}
                easySwitch={easySwitch(history, user, setGsSelectedTab, setSubscriptionSelectedTab, setOthersSelectedTab)}
            />
            <div className='r-c-c' >
                <div className=' m-t-100 m-l-10' style={{ width: "80%" }}>
                    <div style={{ fontSize: 18, fontWeight: 600 }} className="m-t-20">
                        Support details
                    </div>
                    <div style={{ color: "#636363" }}>
                        Contact details for students and staff to reach out with enquiries.
                    </div>
                </div>
            </div>
            <div className='r-c-c m-t-40'>
                <Row style={{ width: "80%" }} gutter={20}>
                    {phoneList?.map((phone, index) => (
                        <Col key={index} sm={{ span: 24 }} md={{ span: 12 }}>
                            <div style={{
                                display: "flex",
                                alignItems: "flex-start",
                                width: "100%", gap: 8
                            }}>
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <ProfileInput
                                        label={"Phone number " + (index + 1)}
                                        type="phone"
                                        value={phone}
                                        disabled={user.privilage.includes("SuperAdmin") ? false : true}
                                        onChange={e => handleChange(e, index)}
                                    />
                                    {errors[index] && (
                                        <div style={{color: "red", fontSize: 12, minHeight: 16}}> {errors[index]} </div>
                                    )}
                                </div>
                                {user.privilage.includes("SuperAdmin") && ( phoneList.length > 1 ) ?
                                    <CloseCircleOutlined className=" cursor-pointer" style={{ color: 'red', fontSize: 14, flexShrink: 0, marginTop:38 }} onClick={() => removeNumber(index)} /> : null}
                            </div>
                        </Col>
                    ))
                    }
                </Row>
            </div>
            {user.privilage.includes("SuperAdmin") ?
                <div className='r-c-c m-t-20'>
                    <Button type="link"
                        style={{ fontSize: 14 }}
                        onClick={() => handleAddField()}
                        icon={<PlusCircleOutlined />}
                        disabled={
                            (phoneList?.length !== 0 && (!phoneList[phoneList?.length - 1] || phoneList[phoneList?.length - 1] === "")) ||
                            errors.some(err => err && err !== "")
                        }
                    >
                        {phoneList && phoneList.length > 0 ? "ADD MORE" : "ADD A NUMBER"}
                    </Button>
                </div> : null}
            <SaveConfirmation
                handleOk={(callback, buttonCallback) => handleSaveConfirm(callback, buttonCallback)}
                saveConfirmationModal={showConfirmModal}
                onCancel={() => setShowConfirmModal(false)}
            />
        </div>
    );
}

const mapStateToProps = (state) => {
    const { user } = state.session;
    const { supportPhones } = state.profileNew;
    return {
        user,
        supportPhones
    }
}

const mapDispatchToProps = (dispatch) => ({
    saveSupportDetails: (params, callback, buttonCallback) => dispatch(saveSupportDetails(params, callback, buttonCallback)),
    setGsSelectedTab: tab => dispatch(setGsSelectedTab(tab)),
    setSubscriptionSelectedTab: tab => dispatch(setSubscriptionSelectedTab(tab)),
    setOthersSelectedTab: (tab) => dispatch(setOthersSelectedTab(tab)),
})

export default connect(mapStateToProps, mapDispatchToProps)(SupportSettings);